import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { UniversalLink } from "../UniversalLink"
import { NavLink } from "./NavLink"
import { homeNavigation, navigation } from "./navigation"
import "./footer.scss"

export const Footer = () => (
  <footer>
    <nav className="nav">
      <NavLink nav={homeNavigation} />

      <div className="md:flex">
        <ul className="menu">
          {navigation.map(
            (nav) =>
              !nav.home && (
                <li key={nav.name}>
                  <NavLink nav={nav} key={nav.key} />
                </li>
              )
          )}
        </ul>
      </div>

      <UniversalLink to="/terms" className="nav-link nav-link-terms">
        v1.2.0 - Terms
      </UniversalLink>
    </nav>
  </footer>
)
